import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#616A7B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M13.333 1.666H6.666q-5 0-5 5v10.833c0 .459.375.834.833.834h10.834q5 0 5-5V6.666q0-5-5-5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#616A7B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.2",
      d: "M5.834 7.916h8.333M5.834 12.082h5.833"
    }, null, -1)
  ]))]))
}
export default { render: render }